import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { GlobalSearchArticle } from '@pt/models';

@Component({
  standalone: false,
  selector: 'pu-article-card-small',
  templateUrl: './article-card-small.component.html',
  styleUrls: ['./article-card-small.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArticleCardSmallComponent {
  article = input<GlobalSearchArticle>();
}
